/* eslint-disable */
export default {
  region: 'Région',
  calling: 'Appel',
  logout: 'Se déconnecter',
  version: 'Version',
  settings: 'Paramètres',
  selectToDialSMS: 'Sélectionner pour composer ou envoyer un SMS',
  selectToDial: 'Sélectionner pour composer',
  selectToSMS: 'Sélectionner pour envoyer un SMS',
  clickToDial: 'Cliquer pour composer',
  autoCreateLog: 'Créer automatiquement un journal des appels',
  autoCreateSMSLog: 'Créer automatiquement un journal des textos',
  autoLogCalls: 'Journaliser automatiquement les appels',
  autoLogNotes: 'Journaliser automatiquement les notes',
  autoLogSMS: 'Journaliser automatiquement les textos',
  clickToSMS: 'Cliquez pour envoyer un texto',
  logSMSContent: 'Enregistrer le contenu du texto',
  clickToDialSMS: 'Cliquer pour composer ou envoyer un texto',
  logExtensionCall: 'Enregistrer les appels de poste',
  audio: 'Son',
  language: 'Langue',
  feedback: 'Commentaires',
  userGuide: 'Nouveautés',
  quickAccess: 'Paramètre d’accès rapide',
  report: 'Rapport d’analyse',
  shareIdea: 'Proposer une idée',
  openEntityFrom: 'Comportement des objets dans Salesforce',
  ctiPanelSize: 'Taille du panneau de la CTI',
  openInNewTab: 'Ouvrir dans un nouvel onglet',
  openInCurrentTab: 'Ouvrir dans l’onglet actuel',
  reportIssue: 'Signaler un problème',
  contactSupport: 'Communiquer avec le service de soutien',
  selectToDialHint:
    'Pour une expérience optimale, choisissez le numéro à composer avec RingCentral sur la page contenant une grande quantité de numéros de téléphone.',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
